// features/module-master.filter.js

import { STATUS_FIELD } from "modules/swiftboard/components/advance-filter";
import { MODULE_BADGES } from "layouts/SidebarBadge";
import apiModuleMaster from "../api";
import apiRoleAndPermissions from "../../api";
import { getRoleConfig } from "../../role-config";
import { parentModuleLabel } from "./module-master.fields";

// Advanced filter for the module list. Every key must also be in
// MODULE_FILTER_FIELDS in the backend's
// src/api/user_role_module/module_master/controller.js, the whitelist that
// endpoint filters on. Types are documented in
// modules/swiftboard/components/advance-filter/advance-filter.helpers.js.
export const moduleMasterFilterFields = [
  {
    key: "role_fids",
    label: "Assigned Roles",
    type: "select",
    group: "Access",
    optionsKey: "roles",
    optionLabelFormatter: (role) => getRoleConfig(role.role).label,
  },
  { ...STATUS_FIELD, group: "Access" },
  {
    key: "parent_fid",
    label: "Parent Module",
    type: "select",
    group: "Sidebar",
    optionsKey: "parentModules",
    optionLabelFormatter: parentModuleLabel,
  },
  { key: "badge", label: "Badge", type: "enum", group: "Sidebar", values: MODULE_BADGES },
  { key: "created_date", label: "Created Date", type: "datetime", group: "Activity" },
];

const settledRows = (result) => (result.status === "fulfilled" ? result.value?.data?.data || [] : []);

// Dropdown data for the filter, fetched once when the drawer first opens.
export const loadModuleMasterFilterDependencies = async () => {
  const [rolesRes, modulesRes] = await Promise.allSettled([
    apiRoleAndPermissions.getRoles(),
    apiModuleMaster.getAllModules(),
  ]);

  return {
    roles: settledRows(rolesRes),
    // Only top-level modules can be parents (the sidebar has two levels).
    parentModules: settledRows(modulesRes).filter((m) => !m.parent_fid),
  };
};
